import styled from 'styled-components'

import { FemiColor } from '../../constants'

const BUTTON_COLORS = {
  primary: { background: FemiColor.BLACK, text: FemiColor.WHITE },
  secondary: { background: FemiColor.GRAY_LIGHT, text: FemiColor.DARK },
  transparent: { background: 'transparent', text: FemiColor.DARK },
}

type TProps = {
  variant?: keyof typeof BUTTON_COLORS
}

export const FemiButton = styled.button<TProps>`
  width: 100%;
  height: 56px;
  padding: 0 16px;
  border: none;
  border-radius: 16px;
  outline: none;
  cursor: pointer;
  background-color: ${({ variant = 'primary' }) =>
    BUTTON_COLORS[variant].background};
  color: ${({ variant = 'primary' }) => BUTTON_COLORS[variant].text};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;

  &:disabled {
    cursor: default;
    background-color: #999;
  }
`
